import { Controller } from '@hotwired/stimulus';
import AutoNumeric from 'autonumeric';
import { ConfiguracionPrecio } from '../../../../libs/autonumeric';

export default class extends Controller {
  connect() {
    this.selectIva = this.element.querySelector('.iva');
    this.selectIva.addEventListener('change', () => {
      this.#actualizarPvp();
    });

    const inputBaseImponible = this.element.querySelector('.base-imponible');
    // Hay cálculos que si no tenemos 3 decimales no se pueden hacer como por ejemplo
    // poner un importe final de 38€ con 21% de IVA (nos pondría 37.99 si solo tenemos
    // dos decimales)
    this.autoNumericBaseImponible = this.#inicializarAutonumeric(inputBaseImponible, 3);

    const inputPvp = this.element.querySelector('.pvp');
    this.autoNumericPvp = this.#inicializarAutonumeric(inputPvp);

    inputBaseImponible.addEventListener('keyup', () => {
      this.#actualizarPvp();
    });
    inputPvp.addEventListener('keyup', () => {
      this.#actualizarBaseImponible();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  #inicializarAutonumeric(input, decimales) {
    return new AutoNumeric(
      input,
      {
        unformatOnSubmit: true,
        decimalPlaces: decimales || 2,
        ...ConfiguracionPrecio,
      },
    );
  }

  #actualizarPvp() {
    let valor = this.autoNumericBaseImponible.getNumber();
    valor = valor || 0;
    valor *= 1 + (this.#getValorIva() / 100);
    this.autoNumericPvp.set(valor);
  }

  #actualizarBaseImponible() {
    let valor = this.autoNumericPvp.getNumber();
    valor = valor || 0;
    valor /= 1 + (this.#getValorIva() / 100);
    this.autoNumericBaseImponible.set(valor);
  }

  #getValorIva() {
    let iva = 0;
    if (this.selectIva.selectedOptions.length > 0) {
      iva = this.selectIva.selectedOptions[0].dataset.iva || 0;
    }
    return iva;
  }
}
